import { ImageProps } from '@/interfaces/models/image';

export type IngredientProps = {
  cost: number;
  count: number;
  id: string;
  image?: ImageProps;
  name: string;
  description: string;
  posCode: number;
  unit: IngredientUnits;
  unitCount: number;
  projectIngredient: { id: string };
  [key: string]: any;
};

export enum IngredientUnits {
  UNIT = 'UNIT',
  GRAM = 'GRAM',
  MILLILITER = 'MILLILITER'
}
